<template lang="pug">
	.web-service--complex-parameter-selector
		.web-service-param-button.flex-row.space.align-center.justify(v-if="type === 'geoplace'", @click="showGeoplacePopup")
			.flex-row.space-small(:class="{ grey: !geoplace }") {{selectedDisplayValue}}
			.select-action
				fas(icon="magnifying-glass")
		Popup(v-if="geoplacePopupVisible", :popupVisible="geoplacePopupVisible", :height="540", :closeOnOutsideClick="false")
			CartoMapComponent(ref="cartoComponent",
				:showFilters="false",
				:searchPlaceEnabled="true",
				:actionsVisible="true",
				:style="{ height: '440px' }",
				:geoJsonDrawings="geoplaceGeoJson ? [geoplaceGeoJson] : []",
				:mapPosition="mapPosition",
				:addresses="addresses",
				@place-changed="onPlaceChanged")
			template(slot="actions-right")
				DxButton(:text="$tCaption('OK', '@actions')", @click="processGeoPlace", type="success", :disabled="!geoplace || !geoplaceResult.PlaceName")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="geoplacePopupVisible = false")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import Popup from 'app-core/Popup.vue';
	import CartoMapComponent from 'view/carto/CartoMapComponent.vue';
	import circleToPolygon from 'circle-to-polygon';

	export default {
		translationCategory: 'webServiceCaller.StructureBuilder',
		name: 'web-service--complex-parameter-selector',
		components: { DxButton, Popup, CartoMapComponent },
		model: {
		},
		props: ['type', 'name', 'value'],
		data() {
			return {
				selectedResult: null,
				geoplace: null,
				geoplaceGeoJson: null,
				geoplacePopupVisible: false,
				geoplaceResult: {
					PlaceName: null,
					Lat: null,
					Lon: null,
					...(this.value || {})
				}
			};
		},		
		computed: {
			typeInfo() {
				return this.$Data.complexExternalServicesTypes[this.type];
			},
			selectedDisplayValue() {
				return this.geoPlaceDisplayValue || this.name;
			},
			geoPlaceDisplayValue() {
				return this.geoplaceResult?.PlaceName || (this.geoplaceResult?.Lat && this.geoplaceResult?.Lon ? `Lat: ${this.geoplaceResult?.Lat}, Lon: ${this.geoplaceResult?.Lon}` : '');
			},
			mapPosition() {
				return this.geoplaceResult.Lat ? {
					lat: this.geoplaceResult.Lat,
					lng: this.geoplaceResult.Lon,
				} : {}
			},
			addresses() {
				return this.geoplaceResult.PlaceName ? [this.geoplaceResult.PlaceName] : [];
			}
		},
		watch: {
			value(v) {
				_.assign(this.geoplaceResult, v || {});
			}
		},
		mounted() {
		},		
		destroyed() {
			
		},
		methods: {
			showGeoplacePopup() {
				if (__DEBUG__)
					window.complexParameterSelector = this;
				this.geoplacePopupVisible = false;
				setImmediate(() => {
					this.geoplacePopupVisible = true;
				});
			},
			processGeoPlace() {
				this.$emit('change', this.geoplaceResult);
				this.geoplacePopupVisible = false;
			},
			async onPlaceChanged(v, name) {
				this.geoplace = v;
				Object.keys(this.geoplaceResult).map(f => this.geoplaceResult[f] = null);

				let osPlace = await this.$Data.getLocationGeoJson({ q: v?.place?.formatted_address || name }).finally(() => this.isLoading--);
				let geoJsonItem = osPlace[0]?.geojson;
				this.geoplaceGeoJson = `${geoJsonItem?.type}`.toLowerCase().indexOf('polygon') > -1 ? geoJsonItem : circleToPolygon([v?.lng, v?.lat], 100, { numberOfEdges: 32 });
				if (__DEBUG__)
					console.debug('onPlaceChanged', { osPlace, geoplace: v, geoJsonItem, geoplaceGeoJson: this.geoplaceGeoJson });
				const state = v?.place?.address_components?.find(f => f.types?.includes('administrative_area_level_1'));
				const county = v?.place?.address_components?.find(f => f.types?.includes('administrative_area_level_2'));
				const country = v?.place?.address_components?.find(f => f.types?.includes('country'));
				const city = v?.place?.address_components?.find(f => f.types?.includes('locality'));
				this.geoplaceResult = {
					Lat: v?.lat,
					Lon: v?.lng,
					PlaceName: name || v?.place?.name,
					State: state?.long_name,
					County: county?.long_name,
					Country: country?.long_name,
					City: city?.long_name
				}
				setImmediate(() => {
					if (this._isDestroyed) return;
					if (this.$refs.cartoComponent)
						this.$refs.cartoComponent.fitDrawnItems();
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.web-service--complex-parameter-selector {
	}
</style>
